var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Caminho_8","data-name":"Caminho 8","d":"M1057.182,3733.083a15.182,15.182,0,1,0,15.182,15.182A15.182,15.182,0,0,0,1057.182,3733.083Zm3.273,15.492h-2.117v6.692h-2.768v-6.692h-1.9v-2.461h1.789a16.512,16.512,0,0,1,.121-2.473c0-.008,0-.015,0-.021v0c.833-3.214,5.025-2.212,5.1-2.194h0v2.248s-2.144-.248-2.295,1.059v1.384h2.3Z","transform":"translate(-1042 -3733.083)","fill":"#fff","fillRule":"evenodd"}));
}

Facebook.defaultProps = {"width":"30.364","height":"30.364","viewBox":"0 0 30.364 30.364"};

module.exports = Facebook;

Facebook.default = Facebook;
